import Link from '@cloudscape-design/components/link';
import Button from '@cloudscape-design/components/button';
import { badgePhotoUrl, phoneToolUrl } from '../lib/externalUrls';

interface PersonChipProps {
  /** Amazon login / alias */
  login: string;
  /** Display name */
  name: string;
  /** Optional subtitle — title, role, etc. */
  subtitle?: string;
  /** Show a remove/clear button */
  onRemove?: () => void;
  /** Icon to use for the remove button — 'close' for form field clear, 'remove' for destructive delete */
  removeIcon?: 'close' | 'remove';
  /** Extra top margin — useful when rendered below a form field */
  marginTop?: string;
}

/**
 * Reusable person chip with badge photo, name, phonetool link, and optional remove button.
 * Used for org leaders, program admins, and user selection previews throughout the app.
 */
export function PersonChip({ login, name, subtitle, onRemove, removeIcon = 'close', marginTop }: PersonChipProps) {
  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      padding: '6px 12px 6px 6px',
      background: '#f2f3f3',
      borderRadius: '8px',
      minWidth: '230px',
      marginTop: marginTop,
    }}>
      <img
        src={badgePhotoUrl(login)}
        alt={name}
        style={{ width: 32, height: 32, borderRadius: 5, objectFit: 'cover', flexShrink: 0 }}
      />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: '14px' }}>{name}</div>
        <div style={{ fontSize: '12px', color: '#5f6b7a' }}>
          <Link href={phoneToolUrl(login)} external fontSize="body-s">
            @{login}
          </Link>
          {subtitle && <span> — {subtitle}</span>}
        </div>
      </div>
      {onRemove && (
        <Button variant="icon" iconName={removeIcon} ariaLabel="Remove" onClick={onRemove} />
      )}
    </div>
  );
}
